"use client";

import { createContext, FC, useMemo, useState } from "react";

export interface IAppContext {
  searchedByLocation: boolean;
  setSearchedByLocation: (searchedByLocation: boolean) => void;
}

interface AppProviderProps {
  children?: React.ReactNode;
}

export const AppContext = createContext<IAppContext | null>(null);

export const AppProvider: FC<AppProviderProps> = ({ children }) => {
  const [searchedByLocation, setSearchedByLocation] = useState(false);

  const value = useMemo(
    () => ({
      searchedByLocation,
      setSearchedByLocation,
    }),
    [searchedByLocation],
  );

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};
